<template>
  <div id="app">
    <!-- 暖白柔光装饰 -->
    <div class="brand-ambient-glow glow-top"></div>
    <div class="brand-ambient-glow glow-middle"></div>
    <div class="brand-ambient-glow glow-bottom"></div>
    <div class="brand-ambient-rings"></div>
    
    <!-- 路由主视口 -->
    <div class="app-main-content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
}
</script>

<style lang="scss">
@import "@/assets/custom_theme.scss";

#app {
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'SF Pro Text', 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2D2723;
  background-color: #FBF6EE;
  background-image: 
    radial-gradient(ellipse 90% 40% at 50% -2%, rgba(235, 99, 91, 0.12) 0%, transparent 70%),
    radial-gradient(ellipse 70% 30% at 90% 40%, rgba(255, 160, 153, 0.08) 0%, transparent 60%),
    linear-gradient(180deg, #FFFDFD 0%, #FAF5F4 45%, #F5ECEB 100%);
  min-height: 100vh;
  max-width: 500px;
  margin: 0 auto;
  position: relative;
  overflow-x: hidden;
  box-shadow: 0 0 40px rgba(180, 140, 100, 0.15);
}

/* 珊瑚暖光柔和氛围 */
.brand-ambient-glow {
  position: fixed;
  pointer-events: none;
  z-index: 0;
  border-radius: 50%;
  filter: blur(80px);
}

.glow-top {
  top: -80px;
  left: 50%;
  transform: translateX(-50%);
  width: 360px;
  height: 220px;
  background: radial-gradient(circle, rgba(235, 99, 91, 0.14) 0%, rgba(255, 160, 153, 0.05) 50%, transparent 75%);
}

.glow-middle {
  top: 35%;
  right: -60px;
  width: 240px;
  height: 240px;
  background: radial-gradient(circle, rgba(243, 120, 112, 0.08) 0%, transparent 70%);
}

.glow-bottom {
  bottom: -60px;
  left: 50%;
  transform: translateX(-50%);
  width: 380px;
  height: 220px;
  background: radial-gradient(circle, rgba(235, 99, 91, 0.10) 0%, transparent 75%);
}

/* 柔和装饰圈 */
.brand-ambient-rings {
  position: fixed;
  top: -60px;
  right: -60px;
  width: 260px;
  height: 260px;
  border-radius: 50%;
  border: 1.5px dashed rgba(235, 99, 91, 0.15);
  pointer-events: none;
  z-index: 0;

  &::before {
    content: '';
    position: absolute;
    top: 24px;
    left: 24px;
    right: 24px;
    bottom: 24px;
    border-radius: 50%;
    border: 1px solid rgba(235, 99, 91, 0.08);
  }
}

.app-main-content {
  position: relative;
  z-index: 1;
}
</style>
